import {createBridgeCaller} from '../BridgeApi';
import {createClassLogger, Logger} from '../../utils/Logging';
import {NotificationBridge, NotificationResponseCallback} from '../notificationBridge';

const BRIDGE_NAME = 'notification';
const logger: Logger = createClassLogger('NotificationBridge:Launcher');
const executeNotificationBridgeCall = createBridgeCaller(BRIDGE_NAME, logger);

const notificationLauncher: NotificationBridge = {
    registerResponseCallback: (callback: NotificationResponseCallback): Promise<void> =>
        executeNotificationBridgeCall('registerresponsecallback', [callback])
};

export default notificationLauncher;
